import React, { Component } from 'react';
import { connect } from 'react-redux'
import { showReferrals } from '../../../../Actions/showReferralsAction'
class PageHeader extends Component {
    state = {}

    
    render() { 
        return ( 
            <div className="container text-center dashboardHeader">
                <div className="row">
                    <div className="col-xl-4">
                    <button id="logout-btn" className="btn btn-primary addReferralsBtn" onClick={this.props.showReferrals}> <i className="fas fa-user-plus"></i> Add A Referral</button>
                    </div>
                    <div className="col-xl-4">
                        <input className="searchInput" id="searchInputBox" type="text" placeholder="Search Name..." onFocus={this.search} onChange={(event) => this.setState({ search: event.target.value})}/>
                    </div>
                </div>
                <hr/>
            </div>
         )
    }
}
 
const mapStateToProps = state => ({
 
})

const mapDispatchToProps = (dispatch) => {
    return {
        
        showReferrals: () => dispatch(showReferrals("")),
        
        
  }
}
export default connect(mapStateToProps, mapDispatchToProps) (PageHeader);


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/PageHeader/PageHeader.jsx